<template>
  <div>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {

  },
};
</script>


<style src="../assets/site.css"></style>
